import React from "react";
import { IconButton, Badge } from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/People";

const ParticipantButtonWithBadge = ({ onClick, style, title, count = 0 }) => {
  return (
    <IconButton style={style} title={title} onClick={onClick}>
      <Badge
        variant="dot"
        color="error"
        invisible={count === 0}
        overlap="rectangular"
      >
        <PeopleIcon />
      </Badge>
    </IconButton>
  );
};

export default ParticipantButtonWithBadge;
